<template>
 <div id="audit-view">
   <div class="content">
     <ul class="section-1">
       <li v-for="(item, inddex) in list" v-bind:key="inddex">
         <a :href="pdfHost + item.pdfName" target="_blank">
            <img :src="require('../../assets/images/' + item.images)">
            <p>{{item.title}}</p>
         </a>
       </li>
     </ul>
     <autograph :title="'本页面信息更新于2018年09月01日，信息由相应审计机构提供'"></autograph>
   </div>
 </div>
</template>

<script>
import autograph from '@/components/autograph'
export default {
  data () {
    return {
      list: [
        {
          images: 'audit.png',
          pdfName: '2017-shenji-caiwu.pdf',
          title: '2017年经审计的财报.pdf'
        }
      ]
    }
  },
  mounted () {
    this.verifyLogin().then((res) => {}).catch(() => {})
  },
  components: {
    autograph
  }
}
</script>

<style lang="less">
#audit-view{
  background: #f5f5f5;
  padding-bottom: 20px;
  .content{
    width: 1200px;
    margin: 0 auto;
    background: #fff;
    .section-1{
      width: 1000px;
      margin :0 auto;
      display: flex;
      justify-content: space-around;
      padding-top: 120px;
      padding-bottom: 100px;
      li {
        width: 210px;
        height: 350px;
        margin :0 auto;
        text-align: center;
        a{
          display:inline-block;
          width: 210px;
          height: 300px;
        }
        p{
          margin-top: 30px;
          color:#000;
          font-size: 14px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/dataReport/audit.vue